module.exports = __webpack_public_path__ + "static/media/pager-dot-unselected.64818a2f.svg";